import moment from 'moment';

// Make sure to import these so that the locale is already defined before updating it
import 'moment/dist/locale/en-ca';
import 'moment/dist/locale/fr-ca';

/**
 * @example Sept 13
 */
export const MONTH_DAY = '[month-day]';

/**
 * @example 09/13
 */
export const TWO_DIGIT_MONTH_DAY = '[two-digit-month-day]';

/**
 * @example Sat Sep 13, 1986
 */
export const WEEKDAY_MONTH_DAY_YEAR = '[weekday-month-day-year]';

/**
 * @example Sat Sep 13
 */
export const WEEKDAY_MONTH_DAY = '[weekday-month-day]';
moment.updateLocale('en', {
  longDateFormat: {
    [MONTH_DAY]: 'MMM D',
    [TWO_DIGIT_MONTH_DAY]: 'MM/DD',
    [WEEKDAY_MONTH_DAY_YEAR]: 'ddd MMM D, YYYY',
    [WEEKDAY_MONTH_DAY]: 'ddd MMM D'
  }
});
moment.updateLocale('en-ca', {
  longDateFormat: {
    [MONTH_DAY]: 'MMM D',
    [TWO_DIGIT_MONTH_DAY]: 'MM/DD',
    [WEEKDAY_MONTH_DAY_YEAR]: 'ddd MMM D, YYYY',
    [WEEKDAY_MONTH_DAY]: 'ddd MMM D'
  }
});
moment.updateLocale('fr-ca', {
  longDateFormat: {
    [MONTH_DAY]: 'D MMM',
    [TWO_DIGIT_MONTH_DAY]: 'DD/MM',
    [WEEKDAY_MONTH_DAY_YEAR]: 'ddd D MMM YYYY',
    [WEEKDAY_MONTH_DAY]: 'ddd D MMM'
  }
});

// See https://github.com/moment/moment/issues/5410, moment sets the locale globally when calling moment.updateLocale, so always resetting it to english here.
moment.locale('en');